var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIconBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60938 7.55952C6.60753 6.30496 7.57505 5.26203 8.82622 5.16988C10.0774 5.07774 11.1873 5.96767 11.3692 7.20897C11.5512 8.45027 10.7435 9.62132 9.51848 9.89216C9.2206 9.95093 9.00459 10.2103 9.00068 10.5139V11.2236",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 12.8203C9.08829 12.8203 9.15966 12.8917 9.15966 12.9797C9.15966 13.0678 9.08829 13.1392 9.00024 13.1392C8.9122 13.1392 8.84082 13.0678 8.84082 12.9797C8.84082 12.8917 8.9122 12.8203 9.00024 12.8203",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00033 16.3334C13.0504 16.3334 16.3337 13.0502 16.3337 9.00008C16.3337 4.94999 13.0504 1.66675 9.00033 1.66675C4.95024 1.66675 1.66699 4.94999 1.66699 9.00008C1.66699 13.0502 4.95024 16.3334 9.00033 16.3334Z",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconBold);
export default __webpack_public_path__ + "static/media/help-icon-bold.090fd36fbe34a4e59bddd6ae433e2015.svg";
export { ForwardRef as ReactComponent };